import { genericMemo } from "@redotech/react-util/component";
import classNames from "classnames";
import type { ReactNode } from "react";
import { Flex, type FlexProps } from "../../flex";
import { Text } from "../../text";
import { RedoButton, type RedoButtonProps } from "../buttons/redo-button";
import { RedoTable, RedoTableProps } from "./redo-table";
import * as tableCardStyles from "./redo-table-card.module.css";

// TODO: Pagination would probably be happy to live here. Update borders if/when added
export const RedoTableCard = genericMemo(function RedoTableCard<DATA>({
  className,
  tableProps,
  title,
  subtitle,
  leftButtonProps,
  rightButtonProps,
  shrink,
}: {
  className?: string;
  tableProps: RedoTableProps<DATA>;
  title: ReactNode;
  subtitle?: ReactNode;
  leftButtonProps?: RedoButtonProps;
  rightButtonProps?: RedoButtonProps;
  shrink?: FlexProps["shrink"];
}) {
  return (
    <Flex
      className={classNames(tableCardStyles.cardWrapper, className)}
      dir="column"
      gap="none"
      shrink={shrink}
      w="full"
    >
      {typeof title === "string" ? (
        <Flex
          bottomLeftRadius="none"
          bottomRightRadius="none"
          dir="column"
          gap="xs"
          p="3xl"
          radius="md"
          w="full"
        >
          <Flex justify="space-between" w="full">
            <Text fontSize="md" fontWeight="semibold">
              {title}
            </Text>
            <Flex gap="xs">
              {leftButtonProps && <RedoButton {...leftButtonProps} />}
              {rightButtonProps && <RedoButton {...rightButtonProps} />}
            </Flex>
          </Flex>
          {subtitle &&
            (typeof subtitle === "string" ? (
              <Text fontSize="xs" fontWeight="regular" textColor="tertiary">
                {subtitle}
              </Text>
            ) : (
              subtitle
            ))}
        </Flex>
      ) : (
        title
      )}

      <RedoTable {...tableProps} />
    </Flex>
  );
});
